export default "__VITE_ASSET__DLe8kTcl__"